export class TenantDatabaseConnectionConfig {
	hostName = '';
	port = 5432;
	/**
	 * Optional reader endpoint used for non-transactional reads. Leave empty when the database has no
	 * reader, in which case all queries go to `hostName`. The reader uses the same credentials and
	 * database name as the writer.
	 */
	readerHostName?: string;
	/** The reader endpoint's port. Defaults to `port` when a `readerHostName` is set. */
	readerPort?: number;
	username = '';
	password? = '';
	databaseName?: string;
	connectionTimeOut_MS?: number;
	query_timeout_MS?: number;
	/**	Backend only prop */
	tenantID?: string;
}
